import { render, staticRenderFns } from "./receivedReportDetails.vue?vue&type=template&id=30597169&scoped=true"
import script from "./receivedReportDetails.vue?vue&type=script&lang=js"
export * from "./receivedReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30597169",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30597169')) {
      api.createRecord('30597169', component.options)
    } else {
      api.reload('30597169', component.options)
    }
    module.hot.accept("./receivedReportDetails.vue?vue&type=template&id=30597169&scoped=true", function () {
      api.rerender('30597169', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/receivablesStatistics/receivedReportDetails.vue"
export default component.exports